<template>
  <div>
    <template v-if="icon">
      <v-tooltip bottom open-delay="500">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon color="orange" @click="exportar()" v-bind="attrs" v-on="on">
            <v-icon>mdi-export-variant</v-icon>
          </v-btn>
        </template>
        <span>Alteração não exportada para o protheus.</span>
      </v-tooltip>
    </template>

    <v-btn v-else color="primary" @click="exportar()" :small="small">
      Exportação protheus
    </v-btn>

    <dialog-resultado-exportacao
      v-model="dialog"
      :resultado="resultadoExportacao"
      :error="error"
      @pedido-exportado="$emit('pedido-exportado', $event)"
    ></dialog-resultado-exportacao>
  </div>
</template>

<script>
import ProtheusAPI from "../../../../api/drp/protheus"
import DialogResultadoExportacao from "./DialogResultadoExportacao";

export default {
  name: "IncluirPedidoLojaDrp",
  components: { DialogResultadoExportacao },
  props: {
    pedido: {
      type: Object,
      required: true
    },
    icon: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    dialog: false,
    error: {},
    resultadoExportacao: {}
  }),
  methods: {
    exportar () {
      const confirmado = window.confirm('Deseja realmente exportar pedido para o Protheus?')

      if (confirmado) {
        const headers = this.Helpers.iniciarRequisicao()

        const params = {idpedido: this.pedido.idpedido}

        this.$store.dispatch(
          "loading/addRequisicao",
          ProtheusAPI.IncluirPedidoLojaDrp(headers, params)
            .then((response) => {
              const {token, error, resultado} = response.data
              localStorage.setItem("token", token)
              this.error = error
              this.resultadoExportacao = resultado
              this.dialog = true
            })
            .catch(() => {
              this.Helpers.logout()
            })
        )
      }
    }
  }
}
</script>

<style scoped>
</style>
